/* eslint-disable @typescript-eslint/no-explicit-any */
import Labeled from 'admin/components/atoms/Labeled';
import Select from 'admin/components/atoms/Select';
import React from 'react';
import { GroupBase } from 'react-select';
import styled, { StyledComponentPropsWithRef } from 'styled-components';

const LabeledSelect = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  className,
  labelText,
  required,
  ...rest
}: React.ComponentProps<typeof Select<Option, IsMulti, Group>> &
  StyledComponentPropsWithRef<typeof Labeled>) => (
  <Labeled className={className} labelText={labelText} required={required}>
    <Select {...rest} />
  </Labeled>
);

export default styled(LabeledSelect)`
  ${Select as any} {
    display: inline-block;
    width: 100%;
  }
` as typeof LabeledSelect;
